import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setMessage('');

    try {
      // TODO: Implement forgot password API call
      // For now, just show a success message
      setTimeout(() => {
        setMessage('If an account with that email exists, we\'ve sent you a password reset link.');
        setLoading(false);
      }, 1000);
    } catch (error) {
      setError('Something went wrong. Please try again.');
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: 'var(--background-gray)',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      padding: '48px 24px'
    }}>
      {/* Header Section */}
      <div style={{
        maxWidth: '400px',
        margin: '0 auto',
        width: '100%',
        textAlign: 'center',
        marginBottom: '32px'
      }}>
        <h2 style={{
          fontSize: '32px',
          fontWeight: 'bold',
          color: 'var(--primary-black)',
          marginBottom: '12px',
          lineHeight: 1.2
        }}>
          Forgot your password?
        </h2>
        <p style={{
          fontSize: '16px',
          color: 'var(--text-gray)',
          lineHeight: 1.5,
          margin: 0
        }}>
          Enter your email address and we'll send you a link to reset your password.
        </p>
      </div>

      {/* Form Container */}
      <div style={{
        maxWidth: '400px',
        margin: '0 auto',
        width: '100%'
      }}>
        <div className="card">
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              {/* Error Message */}
              {error && (
                <div style={{
                  backgroundColor: '#fee2e2',
                  border: '1px solid #fecaca',
                  color: '#dc2626',
                  padding: '12px 16px',
                  borderRadius: '8px',
                  marginBottom: '24px',
                  fontSize: '14px',
                  lineHeight: 1.5
                }}>
                  {error}
                </div>
              )}

              {/* Success Message */}
              {message && (
                <div style={{
                  backgroundColor: '#dcfce7',
                  border: '1px solid #bbf7d0',
                  color: '#16a34a',
                  padding: '12px 16px',
                  borderRadius: '8px',
                  marginBottom: '24px',
                  fontSize: '14px',
                  lineHeight: 1.5
                }}>
                  {message}
                </div>
              )}

              {/* Email Input */}
              <div style={{ marginBottom: '24px' }}>
                <label htmlFor="email" className="form-label">
                  Email address
                </label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="form-input"
                  placeholder="Enter your email address"
                  style={{
                    width: '100%',
                    marginTop: '8px'
                  }}
                />
              </div>

              {/* Submit Button */}
              <div style={{ marginBottom: '24px' }}>
                <button
                  type="submit"
                  disabled={loading}
                  className="btn btn-primary"
                  style={{
                    width: '100%',
                    justifyContent: 'center'
                  }}
                >
                  {loading ? 'Sending...' : 'Send reset link'}
                </button>
              </div>
            </form>

            {/* Back to Login Link */}
            <div style={{
              textAlign: 'center',
              paddingTop: '24px',
              borderTop: '1px solid var(--border-gray)'
            }}>
              <Link
                to="/login"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '8px',
                  fontSize: '14px',
                  color: 'var(--primary-yellow)',
                  textDecoration: 'none',
                  fontWeight: '500',
                  transition: 'color 0.2s ease'
                }}
                onMouseEnter={(e) => {
                  e.target.style.color = 'var(--primary-yellow-dark)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.color = 'var(--primary-yellow)';
                }}
              >
                <ArrowLeftIcon style={{ width: '16px', height: '16px' }} />
                Back to sign in
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Additional Help Section */}
      <div style={{
        maxWidth: '400px',
        margin: '32px auto 0',
        width: '100%',
        textAlign: 'center'
      }}>
        <div style={{
          padding: '20px',
          backgroundColor: 'var(--primary-yellow-light)',
          borderRadius: '8px',
          border: '1px solid var(--primary-yellow)'
        }}>
          <h3 style={{
            fontSize: '16px',
            fontWeight: '600',
            color: 'var(--primary-black)',
            marginBottom: '8px'
          }}>
            Need help?
          </h3>
          <p style={{
            fontSize: '14px',
            color: 'var(--text-gray)',
            marginBottom: '16px',
            lineHeight: 1.5
          }}>
            If you're having trouble resetting your password, contact our support team.
          </p>
          <div style={{
            display: 'flex',
            gap: '12px',
            justifyContent: 'center',
            flexWrap: 'wrap'
          }}>
            <a
              href="mailto:support@gcra.gov.za"
              className="btn btn-outline"
              style={{
                fontSize: '14px',
                padding: '8px 16px'
              }}
            >
              Email Support
            </a>
            <Link
              to="/help/faq"
              className="btn btn-outline"
              style={{
                fontSize: '14px',
                padding: '8px 16px'
              }}
            >
              View FAQ
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
